exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1Wj_m{font-family:Roboto\\, Medium,sans-serif}._9r8Wu{font-family:Roboto\\, Light,sans-serif}._24L5V{width:100%;cursor:pointer;background-color:#e4002b}._2ED9o{margin-top:20px}._24L5V:disabled{background-color:#bcbcbd;border-color:#bcbcbd}._195YG:focus,select:focus{border-color:#e4002b!important}._24L5V:focus{-webkit-box-shadow:none;box-shadow:none}", ""]);

// exports
exports.locals = {
	"robotoMedium": "_1Wj_m",
	"robotoLight": "_9r8Wu",
	"input_button": "_24L5V",
	"divFilter": "_2ED9o",
	"input": "_195YG"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Telemedicina/TurnosSolicitudFilter/TurnosSolicitudFilter.css
// module id = 1251
// module chunks = 0 1